import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {UtilsService} from '../../utils/utils.service';

@Injectable()
export class RoutingConfigService {

  constructor(private _utils: UtilsService, private _router: Router) {
  }

  routeRedirect() {
    const usuario = this._utils.getUsuario();
    const urlRequest = window.location.pathname;
    if (usuario) {
      const pathBase = urlRequest.split('/')[1];
      if (usuario['papeis']['vendedor'] === 1 && usuario['papeis']['gerente'] !== 1) {
        if (pathBase === 'mobile') {
          this._router.navigateByUrl(urlRequest);
        } else {
          this._router.navigateByUrl('/mobile');
        }
      } else if (usuario['papeis']['diretor'] === 1 || usuario['papeis']['supervisor'] === 1 ||
        usuario['papeis']['gerente'] === 1) {
        if (pathBase === 'gestao') {
          this._router.navigateByUrl('/gestao').then((e) => {
            this._router.navigateByUrl(urlRequest);
          });
        } else if (pathBase === 'login') {
          this._router.navigateByUrl('/gestao');
        } else if (pathBase === '' || pathBase === '/') {
          this._router.navigateByUrl('/gestao').then((e) => {
            this._router.navigateByUrl('/gestao');
          });
        }
      } else if (usuario['papeis']['super'] === 1) {
        if (pathBase === 'gestao') {
          this._router.navigateByUrl('/gestao').then((e) => {
            this._router.navigateByUrl(urlRequest);
          });
        } else if (pathBase === 'login') {
          this._router.navigateByUrl('/admin');
        } else if (pathBase === '' || pathBase === '/') {
          this._router.navigateByUrl('/admin');
        }
      } else if (pathBase !== 'gestao') {
        this._router.navigateByUrl(urlRequest);
      }
    }
  }
}
